var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useBuildStyleWithTheme } from '@cvent/carina-theme-provider';
var buildStyle = function (_a) {
    var borderColor = _a.borderColor;
    return {
        circle: {
            base: {
                stroke: borderColor.interactive.base,
                transition: 'stroke-dashoffset 0.35s',
                transform: 'rotate(-90deg)',
                transformOrigin: '50% 50%',
                fill: 'transparent'
            }
        },
        wrapper: {
            base: {
                margin: '0.2rem -0.2rem 0 -0.175rem',
                direction: 'ltr'
            }
        }
    };
};
var useStyle = function () {
    var builtStyle = useBuildStyleWithTheme(buildStyle);
    if (!builtStyle) {
        return { circle: {}, wrapper: {} };
    }
    var circle = builtStyle.circle, wrapper = builtStyle.wrapper;
    return {
        circle: __assign({}, circle.base),
        wrapper: __assign({}, wrapper.base)
    };
};
export default useStyle;
